module.exports = __webpack_public_path__ + "img/bg_title.c84de076.png";